var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LogoPlaceholder',[_c('ProgressShow',{staticClass:"pb-3 pr-3 pl-3",attrs:{"downloadProgress":_vm.downloadProgress}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }